import { render } from "./DepositMoneyMain.vue?vue&type=template&id=97e3ca28&scoped=true"
import script from "./DepositMoneyMain.vue?vue&type=script&lang=js"
export * from "./DepositMoneyMain.vue?vue&type=script&lang=js"

import "./DepositMoneyMain.vue?vue&type=style&index=0&id=97e3ca28&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e3ca28"]])

export default __exports__